import Board from './test';

export default Board;